$ = require 'jquery'
Action = require 'app/scripts/models/action'
ActionList = require 'app/scripts/models/collections/action-list'
ActionListView = require 'app/scripts/views/action/action-list-view'
{ Analytics } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
Backgrounds = require 'app/scripts/data/backgrounds'
BoardSidebarPowerUpSlotsView = require 'app/scripts/views/board-menu/board-sidebar-power-up-slots-view'
idButlerPowerUp = require 'app/scripts/data/butler-id'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
{ TrelloStorage } = require '@trello/storage'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
boardMenuTemplate = require 'app/scripts/views/templates/board_menu_default'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
l = require 'app/scripts/lib/localize'
{ featureFlagClient } = require '@trello/feature-flag-client'
localizeCount = require 'app/scripts/lib/localize-count'
{ asNumber } = require 'app/common/lib/util/i18n/formatters'
{ logError } = require 'app/scripts/debug/log-error'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
ViewWithActions = require 'app/scripts/views/internal/view-with-actions'
LatestPowerUpsMessage = require 'app/scripts/data/latest-power-ups-message'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'

module.exports = class BoardSidebarDefaultView extends View
  mixin ViewWithActions, @
  viewTitleKey: 'menu'

  viewIcon: 'member'

  className: 'board-menu-content-frame'

  headerDisplayTypeClass: 'is-board-menu-default-view'

  initialize: ({ @sidebarView }) ->

    @numActionsToShow = 15

    @makeDebouncedMethods 'render', 'renderMembers'

    @listenTo @model,
      'change:datePluginDisable': @renderPowerUpDisableTimer
      'change:prefs.permissionLevel': @renderDebounced
      'change:prefs.isTemplate': @renderDebounced
      'change:powerUps': @renderEnabledPowerUpCount
      'change:desc': @renderAboutThisBoardSummary
      'change:memberships': @renderAboutThisBoardSummary
      'change:idOrganization': =>
        @renderButlerButton()
        @renderEnabledPowerUpCount()

    @listenTo Auth.me().organizationList, 'change', =>
      @renderDebounced()

    @listenTo @model.boardPluginList,
      'add remove reset': (e) =>
        @renderEnabledPowerUpCount()
        @renderButlerButton()

    @subscribe pluginsChangedSignal(@model), =>
      @renderEnabledPowerUpCount()

    @actionListView = @collectionSubview ActionListView, new ActionList([], { @modelCache }),
      renderOpts:
        limit: @numActionsToShow
        context: @model
        compact: true
        truncateComments: (action) =>
          action.get('date') < @model.get('dateLastView')
        excludeTypes: ['copyCommentCard']

    @waitForId @model, =>
      @listenTo @modelCache, "add:Action:#{ @model.id } remove:Action:#{ @model.id } change:Action:#{ @model.id }", @frameDebounce =>
        @renderActionCount()
        @actionListView.collection.reset(@getActions())

      @actionListView.collection.reset(@getActions())

    @enterpriseUpsellsEnabled = @model.canUpsellToEnterprise() && featureFlagClient.get('enterprise.up_sells', false)

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  events:
    'click .js-about-this-board': 'openAboutThisBoard'
    'click .js-change-background': 'changeBackground'
    'click .js-open-power-ups': (e) ->
      Analytics.sendClickedLinkEvent
        linkName: 'boardMenuPowerUpLink',
        attributes:
          boardId: @model.id
          organizationId: @model.get('idOrganization')
        source: 'boardMenuDrawer',
      @showPowerUps(e)
    'click .js-open-stickers': 'openStickers'
    'click .js-open-card-filter': 'showCardFilter'
    'click .js-open-activity': 'openActivity'
    'click .js-open-more': 'openMore'
    'click .js-power-up-empty-slot': 'showPowerUps'
    'click .js-enterprise-upsell-dismiss': 'enterpriseUpsellDismiss'
    'click .js-enterprise-upsell-learn-more': 'enterpriseUpsellLearnMore'
    'click .js-open-butler': 'openButler'

  renderAboutThisBoardSummary: ->
    canEditDesc = @model.isMember(Auth.me())
    hasDesc = @model.get('desc').length > 0
    @$('.board-menu-about-this-board-summary').toggleClass('hide', hasDesc || !canEditDesc)

    @

  render: ->
    me = Auth.me()

    data =
      editable: @model.editable()
      hasBCPowerUps: me.hasBCPowerUps()
      hasGoldPowerUps: me.isFeatureEnabled('threePlugins')
      isTemplate: @model.isTemplate()
      showEnterpriseUpsell: @enterpriseUpsellsEnabled

    @$el.html(boardMenuTemplate(data))

    if @enterpriseUpsellsEnabled
      idOrganization = @model.get('idOrganization')
      trackUe(Noun.BOARD_SIDEBAR, Verb.SHOWS, Noun.ENTERPRISE_UPSELL, '', '', 'to eligible team member', { idOrganization })
      if @sendGASEvent
        Analytics.sendScreenEvent
          name: 'boardMenuDrawerEnterpriseUpsellInlineDialog'
          containers:
            organization:
              id: idOrganization

    if @$('.js-menu-action-list').length
      @actionListView.setElement(@$('.js-menu-action-list')[0])
      @renderActions()
      @renderActionCount()

    @renderEnabledPowerUpCount()
    @renderBackgroundPreview()
    @renderPowerUpDisableTimer()
    @renderPowerUpSlots()
    @renderAboutThisBoardSummary()
    @renderButlerButton()

    @

  renderBackgroundPreview: ->
    $preview = @$('.js-fill-background-preview').css
      'background-image': ''
      'background-color': ''

    if Backgrounds[@model.getPref('background')]?.tile?
      backgroundImageUrl = @model.getPref('backgroundImage')
    else if @model.getPref('backgroundImageScaled')? || @model.getPref('backgroundImage')?
      backgroundImageUrl =
        Util.previewBetween(@model.getPref('backgroundImageScaled'), 90, 60, 600, 400)?.url ?
        @model.get('fullSizeUrl') ?
        @model.getPref('backgroundImage')

    else if @model.getPref('backgroundColor')?
      backgroundColor = @model.getClientBackgroundColor @model.getPref('background')
    else
      backgroundColor = @model.getClientBackgroundColor "blue"

    $preview.css
      'background-image':
        if backgroundImageUrl
          "url(#{backgroundImageUrl})"
        else
          ''
      'background-color': backgroundColor

    @

  getDateLastViewedActionsStorageKey: ->
    if @model.id
      "timeLastViewedActions-#{@model.id}"
    else
      null

  setDateLastViewedActions: (date) ->
    if (key = @getDateLastViewedActionsStorageKey())?
      TrelloStorage.set key, date.toISOString()
    return

  setDateLastViewedActionsAsNow: ->
    @setDateLastViewedActions new Date()
    return

  getDateLastViewedActions: ->
    if (key = @getDateLastViewedActionsStorageKey())?
      if (isoString = TrelloStorage.get key)?
        return new Date(isoString)
    null

  renderActionCount: ->
    if !@$('.js-unread-activity-count').length
      return

    @$('.js-unread-activity-count').empty()

    dateSince = @getDateLastViewedActions()
    maxNumber = 50

    if !dateSince?
      dateSince = new Date()
      @setDateLastViewedActions(dateSince)

    isCountable = (action) =>
      isNew = new Date(action.get('date')) > dateSince
      isNotMe = action.get('idMemberCreator') != Auth.me().id
      isNew && isNotMe

    count = 0
    for action in @model.getActions()
      if isCountable(action)
        count++

    # we show some comments on the top view which we consider viewed.
    # don't set the actions as viewed if it's 0, because…
    #   1. renderActionCount could have been called before actions were
    #   returned, and we don't want to erroneously set the time and ruin the
    #   count.
    #   2. it's not doing anything anyway
    if 0 < count <= @numActionsToShow
      @setDateLastViewedActionsAsNow()

    countText = count
    if count >= maxNumber
      countText = "#{maxNumber}+"

    if count > @numActionsToShow
      @$('.js-unread-activity-count').text countText

    data =
      count: countText
      hasCount: count > @numActionsToShow

    @$('.js-fill-activity-button').empty().append(
      templates.fill(
        require('app/scripts/views/templates/board_menu_more_activity_button')
        data
      )
    )

    @

  renderPowerUpDisableTimer: ->
    daysRemaining = @model.daysUntilPluginsDisable()
    if daysRemaining != null
      @$('.js-power-up-disable-timer')
        .removeClass('hide')
        .text(localizeCount 'days remaining', daysRemaining)
    else
      @$('.js-power-up-disable-timer').addClass('hide')

  getEnabledPowerUpCount: ->
    @model.get('powerUps').length + @model.powerUpsCount()

  renderButlerButton: ->
    @$('.js-butler-button').toggleClass('hide', !@model.isButlerCore())

  renderEnabledPowerUpCount: ->
    # Show the new banner for the "one power-up for all teams launch"
    me = Auth.me()
    showNew = me && LatestPowerUpsMessage && !me.isDismissed(LatestPowerUpsMessage)

    if showNew
      @$('.js-enabled-power-up-count').text('')
      @$('.js-power-up-new').removeClass('hide')
    else
      @$('.js-power-up-new').addClass('hide')

      count = @getEnabledPowerUpCount()
      if count > 0
        @$('.js-enabled-power-up-count').text(asNumber(count))
      else
        @$('.js-enabled-power-up-count').text('')
    @

  renderActions: ->
    @actionListView.render()
    @

  showPowerUps: (e) ->
    Util.stop(e)
    me = Auth.me()
    if me && LatestPowerUpsMessage && !me.isDismissed(LatestPowerUpsMessage)
      me.dismiss(LatestPowerUpsMessage)

    boardView = @sidebarView.getBoardView()
    boardView.toggleDirectory()

    if !boardView.directoryView
      isEmptySlot = @$(e.target).hasClass('js-power-up-empty-slot')
      if @sendGASEvent
        if isEmptySlot
          Analytics.sendClickedButtonEvent
            buttonName: 'emptyPowerUpSlotButton'
            source: 'boardMenuDrawerDefaultScreen'
            containers:
              board:
                id: @model.id
        else
          @sidebarView.sendClickedDrawerNavItemEvent('default', 'powerUpDirectory')

      ref = if isEmptySlot then 'empty Power-Up slot' else 'Power-Ups button'
      trackUe('board view', 'opens', 'Power-Up directory home page', '', '', "by clicking #{ref} in sidebar")

    daysRemaining = @model.daysUntilPluginsDisable()
    if !daysRemaining
      # Analytics migration: This is handled by the directory screen event
      track("Board Menu", "Open Power-Ups")
    return

  showCardFilter: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'filter'
    return

  openStickers: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'stickers'
    return

  openAboutThisBoard: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'about'
    return

  changeBackground: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'background'
    return

  openActivity: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'activity'
    @setDateLastViewedActionsAsNow()
    return

  openMore: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'more'
    return

  remove: ->
    @unmountBCPrompt?()
    @setDateLastViewedActionsAsNow()
    super

  renderPowerUpSlots: ->
    $powerUpSlotsContainer = @$('.js-power-up-slots-container')
    subview = @subview(BoardSidebarPowerUpSlotsView, @model)
    @appendSubview(subview, $powerUpSlotsContainer)

  enterpriseUpsellDismiss: ->
    idOrganization = @model.get('idOrganization')
    Auth.me().dismiss 'enterprise-upsell-board-sidebar'
    trackUe(Noun.BOARD_SIDEBAR, Verb.DISMISSES, Noun.ENTERPRISE_UPSELL, '', '', 'by clicking "Dismiss"')
    if @sendGASEvent
      Analytics.sendDismissedComponentEvent
        componentType: 'inlineDialog'
        componentName: 'boardMenuDrawerEnterpriseUpsellInlineDialog'
        containers:
          organization:
            id: idOrganization
    @$('.enterprise-up-sell.on-board').remove()

  enterpriseUpsellLearnMore: ->
    idOrganization = @model.get('idOrganization')
    orgType = if @model.getOrganization()?.isBusinessClass() then 'bc' else 'free'
    trackUe(Noun.BOARD_SIDEBAR, Verb.OPENS, Noun.ENTERPRISE_MARKETING_PAGE, '', '', 'by clicking "Learn More"', { idOrganization, orgType } )
    if @sendGASEvent
      Analytics.sendClickedLinkEvent
        linkName: 'learnMoreLink'
        source: 'boardMenuDrawerEnterpriseUpsellInlineDialog'
        containers:
          organization:
            id: idOrganization
            type: orgType
    window.open "/enterprise?app_source=board_sidebar&org_id=#{ idOrganization }&org_type=#{ orgType }"

  openButler: (e) ->
    PluginRunner.one
      plugin: idButlerPowerUp
      command: 'show-settings'
      board: @model
      el: e.currentTarget
